import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { USER_ROLES } from '../../../shared/app-consts';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu-v2.component.html',
  styleUrls: ['./side-menu.component.css']
})
export class SideMenuComponent implements OnInit {

  @Output() close: EventEmitter<any> = new EventEmitter();
  readonly USER_ROLES = USER_ROLES;
  
  constructor() { }

  ngOnInit() {
  }

  closeMenu(){
    this.close.emit();
  }
}
